mutation AddComputedDeliverableMetadataValue(
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier!]!
    $fieldId: ID!
    $value: String!
) {
    addMetadataValue(
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        fieldId: $fieldId
        value: $value
    ) {
        __typename
        ... on MetadataValue {
            _id
            field {
                _id
                name
            }
            value
        }
    }
}
